/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_AthleteInputs */

const en_features_sample_athlete = /** @type {(inputs: Features_Sample_AthleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emma`)
};

const pl_features_sample_athlete = /** @type {(inputs: Features_Sample_AthleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ola`)
};

/**
* | output |
* | --- |
* | "Emma" |
*
* @param {Features_Sample_AthleteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_athlete = /** @type {((inputs?: Features_Sample_AthleteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_AthleteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_athlete(inputs)
	return en_features_sample_athlete(inputs)
});